import type { SiteTexts } from '@cmp/shared';
import { EN_TEXTS } from '@cmp/shared';

/**
 * Languages the visitor can read, best first: the page's own language, then the browser's. Sent to
 * the edge, which picks one and returns only that language's words, so translations never have to
 * ship inside the banner.
 */
export function langCandidates(): string[] {
  const out: string[] = [];
  const add = (l: string | null | undefined) => {
    const v = (l || '').trim().toLowerCase();
    if (v && /^[a-z]{2,3}(-[a-z0-9]{2,8})?$/.test(v) && !out.includes(v)) out.push(v);
  };
  add(document.documentElement.lang);
  for (const l of navigator.languages || [navigator.language]) add(l);
  return out.slice(0, 6);
}

/** Fallback when the config did not come from the edge (inline configs in tests): the site's text or English. */
export function pickTexts(site: Record<string, SiteTexts>, defaultLang: string): { lang: string; texts: SiteTexts } {
  for (const c of [...langCandidates(), defaultLang]) {
    const own = site[c] ?? site[c.slice(0, 2)];
    if (own) return { lang: c.slice(0, 2), texts: { ...EN_TEXTS, ...own, categories: { ...EN_TEXTS.categories, ...own.categories } } };
  }
  return { lang: 'en', texts: EN_TEXTS };
}
